module.exports = __webpack_public_path__ + "img/shor_no.5ff40a35.png";